module.exports = __webpack_public_path__ + "static/media/photo167.e8c925e4.jpg";